<script setup lang="ts">
import SlotsCalendarDay from './SlotsCalendarDay.vue';
import { getDaysPeriod, addMonths } from '@sub/utils/times';

const props = withDefaults(defineProps<{
  minDate?: Date;
  maxDate?: Date;
}>(), {
  minDate: () => new Date(),
});

const focus = defineModel<Date>('focus', { default: () => new Date() });

const days = getDaysPeriod(props.minDate, minDate([addMonths(props.minDate, 24), props.maxDate].filter(Boolean)));

function isEqual(a: Date, b: Date) {
  return a.getDate() === b.getDate() && a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear();
}

const dayIndex = computed(() => Math.max(days.findIndex((d: Date) => isEqual(d, focus.value)), 0));

defineEmits<{
  (e: "start:date", d: Date): void;
}>()
</script>

<template lang="pug">
UiSliderDaySlider(
  :index="dayIndex"
  :items="days"
  @update:focus="$emit('start:date', days[$event])"
)
  template(v-slot="{item}")
    SlotsCalendarDay(:day="item" :active="isEqual(focus, item)" @click="focus = item")
</template>

<style scoped lang="scss">

</style>